/*
 * Copyright 2024 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

/** @alpha */
export const projectTeamManagementTranslationRef = createTranslationRef({
    id: 'project-team-management',
    messages: {
        alerts: {
            projectMembersUpdated: 'Project members updated successfully',
            loadingSaveChangesMessage: 'Saving changes...',
            errorNoUsersSelected: 'No users selected',
            errorNoProjectDetected: 'No project detected',
        },
        button: {
            addMember: 'Add member',
            saveChanges: 'Save changes',
            cancelAddMember: 'Cancel',
            addMemberSelected: 'Add selected',
        },
        table:{
            title: 'Project Team Members',
            projectManager: 'Project Manager',
            columns: {
                user: 'User',
                email: 'Email',
                rol: 'Role',
                actions: 'Actions',
                copilot: 'GitHub Copilot',
            }
        },
        copilot: {
            status: {
                assigned: 'Assigned',
                not_assigned: 'Not assigned',
                pending_org_invitation: 'Invitation pending',
                pending_cancellation: 'Pending cancellation',
                not_in_org: 'Not in organization',
                unknown: 'Unknown',
                error: 'Error',
                loading: 'Loading...',
            },
            action: {
                assign: 'Assign',
                revoke: 'Revoke',
                invite: 'Invite',
            },
            pendingUntil: 'Access ends on {{date}}',
        pendingSave: 'Pending team save',
            alerts: {
                assigning: 'Assigning Copilot license to {{email}}...',
                assigned: 'Copilot license assigned to {{email}}',
                assignFailed: 'Could not assign Copilot license to {{email}}',
                revoking: 'Revoking Copilot license from {{email}}...',
                revoked: 'Copilot license revoked from {{email}}',
                revokeFailed: 'Could not revoke Copilot license from {{email}}',
                inviting: 'Inviting {{email}} to the organization...',
                invited: 'Invitation processed for {{email}}',
                inviteFailed: 'Could not invite {{email}} to the organization',
            },
        },
        dialog: {
            title: 'Add members from catalog',
            searchLabel: 'Search users from catalog',
            searchPlaceholder: 'Write to search users',
            searchHelperText: 'Type at least 3 characters to search',
            loadingUsers: 'Loading users...',
        }
    },
});
